/* Product page: variant resolution, gallery/color-swatch sync, qty, AJAX add-to-cart.
   Falls back to the native /cart/add form post when JS is unavailable. */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-lg-product]');
    if (!root) return;
    var variants = JSON.parse(root.querySelector('[data-lg-variants]').textContent);
    var optionNames = JSON.parse(root.querySelector('[data-lg-options]').textContent);
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = root.querySelector('[data-lg-qty]');
    var addBtn = root.querySelector('[data-lg-add]');
    var priceEl = root.querySelector('[data-lg-price]');
    var mainImg = root.querySelector('[data-lg-main-img]');
    var colorLabel = root.querySelector('[data-lg-color-name]');
    var msgEl = root.querySelector('[data-lg-msg]');
    var colorIdx = optionNames.findIndex(function (n) { return /colou?r/i.test(n); });

    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    var selected = current.options.slice();

    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    function sized(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

    function highlightThumb() {
      var thumbs = root.querySelectorAll('[data-lg-thumb]');
      if (colorIdx > -1) {
        thumbs.forEach(function (t) {
          if (t.dataset.lgColor) t.classList.toggle('lg-thumb--active', t.dataset.lgColor === selected[colorIdx]);
        });
      }
    }

    function resolve() {
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.every(function (o, j) { return o === selected[j]; })) { match = variants[i]; break; }
      }
      root.querySelectorAll('[data-lg-opt]').forEach(function (btn) {
        var oi = parseInt(btn.dataset.lgOptIndex, 10);
        btn.classList.toggle('lg-pill--active', selected[oi] === btn.dataset.lgOpt);
      });
      if (!match) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      current = match;
      idInput.value = match.id;
      priceEl.textContent = money(match.price);
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? addBtn.dataset.lgLabel : 'Sold out';
      if (match.featured_image && mainImg) mainImg.src = sized(match.featured_image.src, 1200);
      highlightThumb();
      if (colorLabel && colorIdx > -1) colorLabel.textContent = selected[colorIdx];
      try { history.replaceState(null, '', location.pathname + '?variant=' + match.id); } catch (e) {}
    }

    root.querySelectorAll('[data-lg-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selected[parseInt(btn.dataset.lgOptIndex, 10)] = btn.dataset.lgOpt;
        resolve();
      });
    });

    root.querySelectorAll('[data-lg-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.dataset.lgColor && colorIdx > -1) {
          selected[colorIdx] = t.dataset.lgColor;
          resolve();
        } else if (mainImg && t.dataset.lgSrc) {
          mainImg.src = t.dataset.lgSrc;
          root.querySelectorAll('[data-lg-thumb]').forEach(function (o) { o.classList.remove('lg-thumb--active'); });
          t.classList.add('lg-thumb--active');
        }
      });
    });

    root.querySelectorAll('[data-lg-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.lgQtyStep, 10));
        qtyInput.value = n;
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      msgEl.textContent = '';
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            msgEl.textContent = res.data.description || res.data.message || 'Could not add to cart.';
            addBtn.disabled = false;
            return;
          }
          addBtn.textContent = 'Added to cart ✓';
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            if (window.lgSetCartCount) window.lgSetCartCount(cart.item_count);
            setTimeout(function () { addBtn.textContent = addBtn.dataset.lgLabel; addBtn.disabled = !current.available; }, 2000);
          });
        })
        .catch(function () { msgEl.textContent = 'Network error — please try again.'; addBtn.disabled = false; });
    });

    resolve();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
